import { TIdentifiers, TTypes, TGroupLoyaltys } from './tercero.interface';
export const CLIENT_TTL_ES = 'Clientes';

export interface IClientBase {
  identifierId: number; //DNI,RUC,PASAPORTE
  idNumber: string;
  typeId: number; //(1)persona natural, (2)persona juridica
  groupLoyaltyId: number; //(1)low,(2)medium,(3)high
  name: string;
  address: string;
  phone: string;
  email: string;
}
export interface IClient extends IClientBase {
  id: number;
  tagStatusColor: string;
}
export interface IClientTable extends IClient {
  identifier: TIdentifiers;
  type: TTypes;
  groupLoyalty: TGroupLoyaltys;
}
export type IClientUpdate = Partial<IClientBase>;
